import { createSelector } from '@reduxjs/toolkit'

import { getLyraTherapyState } from '../../data/lyraTherapy/clientSelectors'
import { RootState } from '../../data/store'

const getVideoSessionState = createSelector(getLyraTherapyState, (lyraTherapyState) => lyraTherapyState?.video)

// Persisted separately from the video session state so a dismissal survives a refresh
const getInformedConsentBannerDismissedAppointmentId = (state: RootState) =>
  state?.informedConsentBanner?.dismissedAppointmentId ?? null

export const getLTVideoSessionAppointment = createSelector(
  getVideoSessionState,
  (videoSessionState) => videoSessionState.videoSessionAppointment,
)

export const getLTVideoSessionAppointmentId = createSelector(
  getLTVideoSessionAppointment,
  (videoSessionAppointment) => videoSessionAppointment?.appointmentId ?? null,
)

export const getLTVideoSessionOpen = createSelector(
  getLTVideoSessionAppointmentId,
  (videoSessionAppointmentId) => videoSessionAppointmentId !== null,
)

export const getPrivacyGuardOn = createSelector(
  getVideoSessionState,
  (videoSessionState) => videoSessionState.privacyGuardOn,
)

export const getInformedConsentBannerDismissed = createSelector(
  getLTVideoSessionAppointmentId,
  getInformedConsentBannerDismissedAppointmentId,
  (videoSessionAppointmentId, dismissedAppointmentId) =>
    videoSessionAppointmentId !== null && dismissedAppointmentId === videoSessionAppointmentId,
)

export const getInformedConsentBannerHeight = createSelector(
  getVideoSessionState,
  (videoSessionState) => videoSessionState.informedConsentBannerHeight,
)

export const getIsPrivacyGuardActive = createSelector(
  getLTVideoSessionOpen,
  getPrivacyGuardOn,
  (videoSessionOpen, privacyGuardOn) => videoSessionOpen || privacyGuardOn,
)
